import { type MessageDescriptor } from 'react-intl';

import { jsmPortalPlaygroundMessages as messages } from './jsm-portal-playground-messages';

export type TeamTabValue = 'it-support' | 'it-operations' | 'engineering' | 'hr';

export type TeamNavigationConfig = {
	avatarAppearance: 'default' | 'outlined';
	avatarInitial: 'A' | 'B' | 'P';
	showAskRovo: boolean;
	showBack: boolean;
	showCreate: boolean;
	showCustomizeHelpCenter: boolean;
	showSearch: boolean;
};

export type TeamTab = {
	label: MessageDescriptor;
	value: TeamTabValue;
};

export const teamTabs: TeamTab[] = [
	{ label: messages.teamItSupport, value: 'it-support' },
	{ label: messages.teamItOperations, value: 'it-operations' },
	{ label: messages.teamEngineering, value: 'engineering' },
	{ label: messages.teamHr, value: 'hr' },
];

export const teamNavigationConfig: Record<TeamTabValue, TeamNavigationConfig> = {
	'it-support': {
		avatarAppearance: 'outlined',
		avatarInitial: 'A',
		showAskRovo: false,
		showBack: true,
		showCreate: false,
		showCustomizeHelpCenter: true,
		showSearch: false,
	},
	'it-operations': {
		avatarAppearance: 'default',
		avatarInitial: 'P',
		showAskRovo: true,
		showBack: false,
		showCreate: true,
		showCustomizeHelpCenter: false,
		showSearch: true,
	},
	engineering: {
		avatarAppearance: 'default',
		avatarInitial: 'A',
		showAskRovo: true,
		showBack: false,
		showCreate: true,
		showCustomizeHelpCenter: false,
		showSearch: true,
	},
	hr: {
		avatarAppearance: 'default',
		avatarInitial: 'B',
		showAskRovo: true,
		showBack: false,
		showCreate: true,
		showCustomizeHelpCenter: false,
		showSearch: true,
	},
};
